import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { Session } from '../../session';
import { SessionService } from '../../session.service';

import { AppConst } from '../../app-const';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(
    private sessionService: SessionService,
    private router: Router,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.sessionService.authObservable.pipe(map((session: Session) => {
      if (!session.isLogin) {
        this.router.navigate([AppConst.ROUTING_LINK_SIGN_IN]);
        return false;
      } else {
        if (session.user) {
          if (session.user.user_type == AppConst.MANAGE_USER_TYPE_ADMIN) {
            return true;
          } else {
            this.router.navigate([AppConst.ROUTING_LINK_TOP]);
            return false;
          }
        } else {
          this.sessionService.logout();
          return false;
        }
      }
    }))
  }
  
}
